import React from 'react';
import { Clock, CalendarClock } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

interface BadgeProps {
  label: string;
  variant?: 'blue' | 'yellow';
}

export const Badge: React.FC<BadgeProps> = ({ 
  label, 
  variant = 'blue'
}) => {
  const colorClass = variant === 'blue' ? 'bg-blue-500' : 'bg-yellow-500';
  const tooltipText = variant === 'blue' ? 'Kdy je výplata' : 'Jak dlouho platí';
  const Icon = variant === 'blue' ? Clock : CalendarClock;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <div className={`inline-flex ${colorClass} text-white text-xs font-bold px-2 py-1 rounded-full shadow-md items-center gap-1`}>
            <Icon size={12} />
            {label}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}; 